import "./Footer.css";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  FiInstagram,
  FiLinkedin,
  FiMail,
  FiArrowUp,
  FiShield,
  FiCpu,
  FiActivity,
} from "react-icons/fi";
import brandLogo from "../../assets/images/bybebeklogo.png";

function Footer() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 250);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    whileInView: {
      opacity: 1,
      y: 0,
    },
  };

  return (
    <>
      <button
        className={`scroll-top ${showButton ? "show" : ""}`}
        onClick={scrollTop}
        aria-label="Yukarı çık"
      >
        <FiArrowUp />
      </button>

      <footer className="footer">
        <div className="footer-glow"></div>

        <div className="container">
          <div className="footer-content">
            <motion.div
              className="footer-brand"
              variants={fadeUp}
              initial="hidden"
              whileInView="whileInView"
              viewport={{ once: true }}
              transition={{ duration: .6 }}
            >
              <img className="footer-logo" src={brandLogo} alt="Bybebek" />

              <p>
                Yapay zeka destekli yeni nesil bebek ebeveyn asistanı.
                Teknolojiyi güven ve huzurla buluşturuyoruz.
              </p>
            </motion.div>

            <motion.div
              className="footer-middle"
              variants={fadeUp}
              initial="hidden"
              whileInView="whileInView"
              viewport={{ once: true }}
              transition={{ delay: .15, duration: .6 }}
            >
              <h4>Akıllı Teknoloji</h4>

              <div className="footer-tags">
                <div className="footer-tag">
                  <FiCpu />
                  Yapay Zeka
                </div>

                <div className="footer-tag">
                  <FiShield />
                  Güvenli
                </div>

                <div className="footer-tag">
                  <FiActivity />
                  Akıllı Takip
                </div>
              </div>
            </motion.div>

            <motion.div
              className="footer-contact"
              variants={fadeUp}
              initial="hidden"
              whileInView="whileInView"
              viewport={{ once: true }}
              transition={{ delay: .3, duration: .6 }}
            >
              <h4>İletişim</h4>

              <a href="mailto:info@bybebek.com">
                <FiMail />
                bybebek@gmail.com
              </a>

              {/* <div className="footer-follow">
                <span>Bizi Takip Edin</span>

                <div className="footer-social">
                  <a href="/" aria-label="Instagram">
                    <span className="social-tooltip">Instagram</span>
                    <FiInstagram />
                  </a>

                  <a href="/" aria-label="LinkedIn">
                    <span className="social-tooltip">LinkedIn</span>
                    <FiLinkedin />
                  </a>
                </div>
              </div> */}
            </motion.div>
          </div>

          <div className="footer-divider"></div>

          <motion.div
            className="footer-bottom"
            initial={{
              opacity: 0,
              y: 25,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{ once: true }}
            transition={{
              delay: .45,
              duration: .6,
            }}
          >
            © 2026 Bybebek • Tüm Hakları Saklıdır. Yapay zeka destekli akıllı
            ebeveyn asistanı.
          </motion.div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
